<template>
    <el-table :data="list" style="width: 100%" row-key="month_id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" v-loading="loading" :show-header="false" empty-text="暂不支持多个月份或多年份的目标完成数据">
        <el-table-column prop="month_name" width="250">
        <template slot-scope="scope">
            <span>{{ scope.row.month_name }}</span>
            <span style="margin-left:15px;">{{ scope.row.name }}</span>
        </template>
        </el-table-column>
        <el-table-column prop="finish_ratio">
        <template slot-scope="scope">
            <span><el-progress :text-inside="true" :percentage="scope.row.finish_ratio ? (scope.row.finish_ratio > 100 ? 100 : (scope.row.finish_ratio < 0 ? 0 : scope.row.finish_ratio)) : 0" :stroke-width="26"></el-progress></span>
        </template>
        </el-table-column>
        <el-table-column prop="finish_amount" width="150">
        <template slot-scope="scope">
            <span>{{ scope.row.finish_amount }} / {{ scope.row.goal_amount }}</span>
        </template>
        </el-table-column>
    </el-table>
</template>
  
<script>
import OrderCount from "~/services/OrderCount";

export default {
    props:{
        params:{
            type: Object,
            required: true,
        },
        table_height:{
            type: String,
            default: '600px',
        }
    },

    data() {
        return {
            loading: false,
            list: [],
        };
    },

    created(){
        this.getList();
    },

    mounted() {
        
    },
    
    methods: {
        getList() {
            this.list = [];
            let params = _.clone(this.params);
            let is_year = false;
            let is_month = false;
            if (!params.hasOwnProperty('year')) {
                params['year'] = 0;
                let start_year = (new Date(params.order_created_at[0])).getFullYear();
                let end_year = (new Date(params.order_created_at[1])).getFullYear();
                if(start_year == end_year){
                    params['year'] = start_year;
                    is_year = true;
                }
            }
            
            if (!params.hasOwnProperty('month')) {
                params['month'] = 0;
                let start_month = (new Date(params.order_created_at[0])).getMonth();
                let end_month = (new Date(params.order_created_at[1])).getMonth();
                if(start_month == end_month){
                    params['month'] = start_month + 1;
                    is_month = true;
                }
            }
            if(is_year && is_month){
                params['is_finish_time'] = 1;
                this.loading = true;
                OrderCount.getPayOrderCount(params, 'goal-finish').then((res) => {
                    if (res.code == 0 && res.data) {
                        this.list = res.data.list;
                    }
                    this.loading = false;
                });
            }
        },
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/count/table/goalProgress.vue